import auth from '@/auth/index'
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    meta: {
      title: '加密计算',
      breadLevel: 0,
      icon: 'icon-contractdetector'
    },
    children: [
      {
        path: '/encryption-user',
        name: 'encryptionUser',
        component: resolve => require(['@/views/cryptographicComputations/user.vue'], resolve),
        meta: {
          title: '用户管理',
          breadLevel: 0
        }
      },
      {
        path: '/encryption-create',
        name: 'encryptionCreate',
        component: resolve =>
          require(['@/views/cryptographicComputations/encryptionCreate.vue'], resolve),
        meta: {
          title: '新建链上数据',
          breadLevel: 0
        }
      },
      {
        path: '/encryption-search',
        name: 'encryptionSearch',
        component: resolve =>
          require(['@/views/cryptographicComputations/encryptionSearch.vue'], resolve),
        meta: {
          title: '链上数据检索',
          breadLevel: 0
        }
      }
    ]
  }
]

export default routes
